import React, { Component } from 'react';
import './Login.css';

class Login extends React.Component {
  render() {
   return (
     <div className="Login">
       <div className="LoginForm">
         <h2>ログイン</h2>
         <label><b>メールアドレス</b></label>
            <input type="text" name="uname" onChange={this.props.handleInputChange} required />
            <label><b>パスワード</b></label>
            <input type="password" name="psw" onChange={this.props.handleInputChange} required />
              <button className="Login-Btn" onClick={this.props.loginCheck} type="submit">
               ログイン
             </button>
       </div>

     </div>
   );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/Login.js